import * as React from 'react';

import { COLOR } from '../constants';
import { ResponsiveContainerProps } from '../components/ResponsiveContainer';
import { UnorderedList } from '../components/UnorderedList';
import thumbnail from '../images/ielts-course-thumbnail.jpg';
import {
  ThumbnailPromotionBanner,
  ThumbnailPromotionBannerProps,
} from '../ThumbnailPromotionBanner';
import { environment } from '@doltech/core/lib/environment/environment';

interface IeltsCourseThumbnailPromotionBannerProps
  extends ResponsiveContainerProps,
    Pick<ThumbnailPromotionBannerProps, 'disabled'> {}

export const IeltsCourseThumbnailPromotionBanner = (
  props: IeltsCourseThumbnailPromotionBannerProps
) => {
  return (
    <ThumbnailPromotionBanner
      thumbnail={thumbnail}
      label="Khóa học IELTS"
      title="Khoá học IELTS Tư Duy tại DOL IELTS Đình Lực"
      renderContent={() => (
        <UnorderedList
          maxWidth={440}
          list={['Band điểm tăng nhanh', 'Giỏi ứng dụng', 'Tăng tư duy']}
        />
      )}
      action={{
        text: 'Tìm hiểu',
        url: environment.REACT_APP_DOL_CORP_WEBSITE_HOST_NAME,
      }}
      color={COLOR.BLUE}
      {...props}
    />
  );
};
